import Vue from "vue/dist/vue.esm.js"
import FacilitiesList from '../components/facilitiesList.vue'

new Vue({
  el: 'facilities-list',
  components: { FacilitiesList },
})